export default __webpack_public_path__ + "static/indignant-df7f3bbee436d8c8af737aafece182ac.svg";